module.exports = __webpack_public_path__ + "img/image-map-2-527055bc.png";